'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { InformationCircleIcon } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
import { usePrizePoolContext } from './prize-pool-context';
export interface PrizePoolHelpButtonProps {
  className?: string;
}

/**
 * Compact info-icon help button. Clicking opens the shared
 * `<PrizePool.HowItWorksModal>` via context — so two `<HelpButton>` instances
 * inside one `<PrizePool.Provider>` open the same modal without controlled
 * state plumbing on either button.
 */
export function PrizePoolHelpButton(t0) {
  const $ = _c(11);
  const {
    className
  } = t0;
  const t = useTranslations("chart");
  const {
    actions: t1
  } = usePrizePoolContext();
  const {
    setHelpModalOpen
  } = t1;
  let t2;
  if ($[0] !== t) {
    t2 = t("prize_pool.help_aria_label");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = cn("text-foreground-secondary/60 transition-colors hover:text-foreground-secondary", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setHelpModalOpen) {
    t4 = () => setHelpModalOpen(true);
    $[4] = setHelpModalOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon icon={InformationCircleIcon} className="size-3.5" aria-hidden="true" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t6 = <button type="button" aria-label={t2} className={t3} onClick={t4}>{t5}</button>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}